import CarrierAssembly from "@/pages/mill/carriers";
import { CarrierBuildFormPage } from "@/pages/mill/carriers/components/build/CarrierBuildFormPage";
import CobblesManager from "@/pages/mill/cobbles/manager";
import Dashboard from "@/pages/mill/gantt";
import MillOverview from "@/pages/mill/overview";
import MillOverview2 from "@/pages/mill/overview-2";
import RejectedManager from "@/pages/mill/rejected/manager";
import Campaign from "@/pages/mill/schedule";
import { UtilityManagementPage } from "@/pages/utility/management/UtilityManagementPage";
import { UtilityEngineeringPage } from "@/pages/utility/engineering/UtilityEngineeringPage";
import { ConsumptionPage } from "@/pages/utility/report/ConsumptionPage";
import { PermissionRoute } from "./PermissionRoute";

export const routeCarrierAssembly = "mill/carriers-assembly";
export const routeMillOverview = "/mill/overview";
export const routeMillOverview2 = "/mill/overview-2";
export const routeMillSchedule = "/mill/schedule";
export const routeCobblesManager = "/mill/cobbles/manager";
export const routeRejectedManager = "/mill/rejected/manager";
export const routeMillGantt = "/mill/gantt";
export const routeUtilityConsumption = "/mill/consumption";
export const utilityConsumptionPermission = "ui.navbar.mill.consumption";
export const routeUtilityEngineering = "/mill/utility-engineering";
export const utilityEngineeringPermission =
	"ui.navbar.mill.utility.engineering";
export const routeUtilityManagement = "/mill/utility-management";
export const utilityManagementPermission = "ui.navbar.mill.utility.management";
export const utilityNavbarPermission = "ui.navbar.utilities";

export const utilityConsumptionRoute = {
	path: routeUtilityConsumption,
	element: (
		<PermissionRoute permission={utilityConsumptionPermission}>
			<ConsumptionPage />
		</PermissionRoute>
	),
	permission: utilityConsumptionPermission,
};

export const utilityEngineeringRoute = {
	path: routeUtilityEngineering,
	element: (
		<PermissionRoute permission={utilityEngineeringPermission}>
			<UtilityEngineeringPage />
		</PermissionRoute>
	),
	permission: utilityEngineeringPermission,
};

export const utilityManagementRoute = {
	path: routeUtilityManagement,
	element: (
		<PermissionRoute permission={utilityManagementPermission}>
			<UtilityManagementPage />
		</PermissionRoute>
	),
	permission: utilityManagementPermission,
};

export const millRoutes = [
	utilityConsumptionRoute,
	utilityEngineeringRoute,
	utilityManagementRoute,
	{
		path: routeCarrierAssembly,
		element: <CarrierAssembly />,
		permission: "ui.navbar.mill.carrier.status",
	},
	{
		path: `${routeCarrierAssembly}/:partId`,
		element: <CarrierAssembly />,
		permission: "ui.navbar.mill.carrier.status",
	},
	{
		path: `${routeCarrierAssembly}/:carrierId/view/:carrierInstanceId`,
		element: <CarrierBuildFormPage />,
		permission: "ui.navbar.mill.carrier.status",
	},
	{
		path: `${routeCarrierAssembly}/:carrierId/build/:carrierInstanceId`,
		element: <CarrierBuildFormPage />,
		permission: "ui.navbar.mill.carrier.status",
	},
	{
		path: `${routeCarrierAssembly}/:carrierId/build/:carrierInstanceId/answer-all`,
		element: <CarrierBuildFormPage />,
		permission: "ui.navbar.mill.carrier.status",
	},
	{
		path: `${routeMillOverview}`,
		element: <MillOverview />,
		permission: "ui.navbar.mill.overview",
	},
	{
		path: `${routeMillOverview2}`,
		element: <MillOverview2 />,
		permission: "ui.navbar.mill.overview2",
	},
	{
		path: `${routeMillSchedule}`,
		element: <Campaign />,
		permission: "ui.navbar.mill.schedule",
	},
	{
		path: `${routeMillSchedule}/:campaignId`,
		element: <Campaign />,
		permission: "ui.navbar.mill.schedule",
	},
	{
		path: `${routeCobblesManager}`,
		element: <CobblesManager />,
		permission: "ui.navbar.mill.cobbles.manager",
	},
	{
		path: `${routeCobblesManager}/:shiftId`,
		element: <CobblesManager />,
		permission: "ui.navbar.mill.cobbles.manager",
	},
	{
		path: `${routeRejectedManager}`,
		element: <RejectedManager />,
		permission: "ui.navbar.mill.rejected.manager",
	},
	{
		path: `${routeRejectedManager}/:shiftId`,
		element: <RejectedManager />,
		permission: "ui.navbar.mill.rejected.manager",
	},
	{
		path: `${routeMillGantt}`,
		element: <Dashboard />,
		permission: "ui.navbar.mill.gantt",
	},
	{
		path: `${routeMillGantt}/:shiftId`,
		element: <Dashboard />,
		permission: "ui.navbar.mill.gantt",
	},
];
